export const ExternalLinkTypes = {
    text: 'text',
    button: 'button',
};
